import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/public/ui";

export default function Solutions() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/solutions").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 relative">
          <Overline><span className="text-[#4CB944]">Solutions logicielles</span></Overline>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-white font-head">Nos solutions</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl">Des logiciels développés et commercialisés par VISION LOGICIELS pour digitaliser votre activité.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="solutions-grid">
          {items.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.06}>
              <Link to={`/solutions/${s.slug}`} data-testid={`solution-card-${s.slug}`}
                className="group block h-full rounded-2xl bg-white border border-slate-200 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all">
                <div className="h-48 overflow-hidden"><img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-6">
                  <div className="text-xs font-mono text-[#4CB944] uppercase tracking-wider mb-2">{s.category}</div>
                  <h3 className="text-xl font-bold text-slate-900 font-head">{s.name}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-2">{s.short_desc}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-sm font-semibold text-[#0F2A6B]">{s.price}</span>
                    <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-[#4CB944] transition-colors" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
          {items.length === 0 && <p className="text-slate-500">Aucune solution publiée pour le moment.</p>}
        </div>
      </section>
    </div>
  );
}
